
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

parcelRegister("eZFA1", function(module, exports) {

$parcel$export(module.exports, "GrantAccessDialogLoaderQuery", () => $4ab52410a046c365$export$1cf432ea3a028ecc);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $4ab52410a046c365$export$1cf432ea3a028ecc = (0, $d2LG0.default)`query GrantAccessDialogLoaderQuery($contentId:ID!$accountId:ID!){singleContent(id:$contentId){id title}user:confluence_atlassianUser(id:$accountId){id displayName photos{value isPrimary}}}`;

});

parcelRegister("hAnPj", function(module, exports) {

$parcel$export(module.exports, "LazyRestrictionsDialogMountPoint", () => $bb619eb96b539cb1$export$8c358bcfa2c0ec3f);
$parcel$export(module.exports, "RestrictionsDialogTriggerWrapper", () => (parcelRequire("SAFLR")).RestrictionsDialogTriggerWrapper);
$parcel$export(module.exports, "RestrictionsDialogTrigger", () => (parcelRequire("lEXFh")).RestrictionsDialogTrigger);
$parcel$export(module.exports, "RestrictionsDialogMenuPropsProvider", () => (parcelRequire("lQDcS")).RestrictionsDialogMenuPropsProvider);

var $jmjWc = parcelRequire("jmjWc");

var $SAFLR = parcelRequire("SAFLR");

var $lEXFh = parcelRequire("lEXFh");

var $lQDcS = parcelRequire("lQDcS");

const $bb619eb96b539cb1$export$8c358bcfa2c0ec3f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qdHUS",
    name: "LazyRestrictionsDialogMountPoint",
    loader: async ()=>(await (parcelRequire("6gsgG"))).RestrictionsDialogMountPoint
});

});
parcelRegister("SAFLR", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDialogTriggerWrapper", () => $84211cd137cf57b0$export$e8086e85d5f7d830);

var $gwFzn = parcelRequire("gwFzn");

var $ln0hx = parcelRequire("ln0hx");
var $irVI7 = parcelRequire("irVI7");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $lEXFh = parcelRequire("lEXFh");
const $84211cd137cf57b0$export$e8086e85d5f7d830 = (props)=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE,
        key: "restrictions-dialog-trigger"
    }, hasAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
        key: "restriction-button-start",
        id: props.contentId,
        name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lEXFh.RestrictionsDialogTrigger), props)) : null);
};

});
parcelRegister("lEXFh", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDialogTrigger", () => $0b24ce56d1d6b617$export$4a978df01c3bf89e);
$parcel$export(module.exports, "startRestrictionsDialogExperience", () => $0b24ce56d1d6b617$export$59974e42a4613c7);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $aJPUt = parcelRequire("aJPUt");
var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $7d2Nc = parcelRequire("7d2Nc");

var $i81rh = parcelRequire("i81rh");

var $euL71 = parcelRequire("euL71");

var $5u6LZ = parcelRequire("5u6LZ");

var $8RR7m = parcelRequire("8RR7m");

var $9wGTI = parcelRequire("9wGTI");

var $c3Qwv = parcelRequire("c3Qwv");
var $7zgzO = parcelRequire("7zgzO");

var $jLw6A = parcelRequire("jLw6A");
var $ckmNl = parcelRequire("ckmNl");

var $bQm3c = parcelRequire("bQm3c");

var $ep3mz = parcelRequire("ep3mz");

var $bVAxT = parcelRequire("bVAxT");

var $14SPd = parcelRequire("14SPd");

var $cSVAY = parcelRequire("cSVAY");

var $eE3dj = parcelRequire("eE3dj");

var $fkOJz = parcelRequire("fkOJz");
const $0b24ce56d1d6b617$var$buttonContainerStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    verticalAlign: 'top'
});
const $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT = 'bottom-end';
const $0b24ce56d1d6b617$export$4a978df01c3bf89e = /*#__PURE__*/ (0, $gwFzn.memo)((props)=>{
    const contentId = (0, $ckmNl.useContentId)(props.contentId) || '';
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [state, setState] = (0, $gwFzn.useState)({
        grantAccessClicked: false,
        hasAutoOpenedRestrictionDialog: false,
        showFreeRestrictionDialog: false
    });
    const contentSubType = props.contentSubType;
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeHandleOpen = (dialogStateContainer)=>()=>$0b24ce56d1d6b617$export$59974e42a4613c7({
                ...useAnalyticsEventsHook,
                actionSubjectId: 'restrictionsDialogButton',
                dialogStateContainer: dialogStateContainer,
                edition: edition,
                experienceTracker: experienceTracker,
                contentType: contentType,
                contentSubType: contentSubType,
                contentId: contentId
            });
    const getParentData = (restrictions)=>{
        const ancestors = restrictions?.ancestors || [];
        for(let i = ancestors.length - 1; i >= 0; i--){
            if (ancestors[i].hasRestrictions) return ancestors[i]; // content
        }
    };
    const handleGrantAccessActionClicked = ()=>{
        setState((state)=>({
                ...state,
                grantAccessClicked: true
            }));
        if (window?.__SSR_EVENTS_CAPTURE__?.restrictionsButton) delete window.__SSR_EVENTS_CAPTURE__?.restrictionsButton;
    };
    const handleFreeEditionPadlockClicked = ()=>{
        setState((state)=>({
                ...state,
                showFreeRestrictionDialog: true
            }));
        if (window?.__SSR_EVENTS_CAPTURE__?.restrictionsButton) delete window.__SSR_EVENTS_CAPTURE__?.restrictionsButton;
    };
    const onFreeDialogClosed = ()=>{
        setState((state)=>({
                ...state,
                showFreeRestrictionDialog: false
            }));
        if (window?.__SSR_EVENTS_CAPTURE__?.restrictionsButton) delete window.__SSR_EVENTS_CAPTURE__?.restrictionsButton;
    };
    const renderFreeEditionDialog = (dialogStateContainer, shouldShowDialog)=>{
        const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props;
        // already free edition
        const shouldSSRViewPageFreeEditionButton = triggeredFrom === 'fromView';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jLw6A.PageRestrictionsContextConsumer), null, ({ loading: loading, error: error, restrictions: restrictions })=>{
            if (!restrictions && loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
            const contentHasRestrictions = Boolean(restrictions?.hasRestrictions || restrictions?.hasInheritedRestrictions);
            const contentHasInheritedRestrictionsOnly = Boolean(restrictions?.hasInheritedRestrictions && !restrictions?.hasRestrictions);
            const immediateParentPageIndex = (restrictions?.ancestors.length || 0) - 1;
            const isChildPage = immediateParentPageIndex > 0;
            // Note: content with restrictions is excluded from the pageRestrictionsExperiment
            if (contentHasRestrictions) {
                if (isChildPage && contentHasInheritedRestrictionsOnly) {
                    const parentData = getParentData(restrictions);
                    return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i81rh.ChangeEditionInlineDialogPaintLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        shouldHideSpinner: state.showFreeRestrictionDialog,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRRendered: true,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i81rh.ChangeEditionInlineDialogLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        shouldHideSpinner: true,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    }));
                }
                if (shouldShowDialog && !state.hasAutoOpenedRestrictionDialog) {
                    makeHandleOpen(dialogStateContainer)();
                    setState((state)=>({
                            ...state,
                            hasAutoOpenedRestrictionDialog: true
                        }));
                }
                // grandfathered content
                return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    shouldHideSpinner: dialogStateContainer.getHideRestrictionsButtonSpinner(),
                    resetDialogState: ()=>dialogStateContainer.initState(),
                    onClick: makeHandleOpen(dialogStateContainer),
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    shouldHideSpinner: true,
                    onClick: makeHandleOpen(dialogStateContainer),
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                });
            }
            return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i81rh.ChangeEditionInlineDialogPaintLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                shouldHideSpinner: state.showFreeRestrictionDialog,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i81rh.ChangeEditionInlineDialogLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                shouldHideSpinner: true,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            }));
        });
    };
    const renderRestrictionsButton = (dialogStateContainer)=>{
        const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props;
        if (triggeredFrom && triggeredFrom === 'fromView') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
            contentId: contentId,
            isDisabled: isDisabled,
            shouldHideSpinner: dialogStateContainer.getHideRestrictionsButtonSpinner(),
            onClick: makeHandleOpen(dialogStateContainer),
            resetDialogState: ()=>dialogStateContainer.initState(),
            restrictionsButtonSSRRendered: true,
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
            contentId: contentId,
            isDisabled: isDisabled,
            shouldHideSpinner: true,
            onClick: makeHandleOpen(dialogStateContainer),
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom
        });
    };
    //  accessType=view&grantAccess=true&username=rwu&userFullName=Robin+Wu
    const renderGrantAccessDialogAndButton = (getQueryParams, dialogStateContainer, shouldShowDialog)=>{
        const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props;
        const queryParams = getQueryParams();
        const shouldSSRGrantAccessRestrictions = triggeredFrom === 'fromView';
        if (shouldShowDialog && !state.grantAccessClicked) {
            const accountId = (0, $c3Qwv.getSingleParam)(queryParams, 'accountId');
            // TODO(brizvash): non-gdpr params, remove when GDPR is on
            // "username" in the URL is actually the accountId in legacy circumstances
            // which we will use to fetch username from backend
            const legacyUsername = (0, $c3Qwv.getSingleParam)(queryParams, 'username') || '';
            // render grant access requested user
            // preloading the queries means that isOpen wil always be true in SSR.
            // here, we set isOpen to false during SSR so the modal doesn't open on SSR (since
            // there is no handling for the inner modal clicks)
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5u6LZ.GrantAccessDialogLoader), {
                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                isOpen: true,
                contentId: contentId,
                onActionClick: handleGrantAccessActionClicked,
                accessType: (0, $c3Qwv.getSingleParam)(queryParams, 'accessType') === 'edit' ? 'edit' : 'view',
                // When accountId is not present, username will have the Id
                accountId: accountId || legacyUsername,
                shouldSSRGrantAccessRestrictions: shouldSSRGrantAccessRestrictions,
                buttonPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null)
            }, shouldSSRGrantAccessRestrictions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                shouldHideSpinner: dialogStateContainer.getHideRestrictionsButtonSpinner(),
                resetDialogState: ()=>dialogStateContainer.initState(),
                onClick: makeHandleOpen(dialogStateContainer),
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "default grant access",
                triggeredFrom: triggeredFrom
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                shouldHideSpinner: true,
                onClick: makeHandleOpen(dialogStateContainer),
                restrictionsButtonSSRLocation: "default grant access",
                triggeredFrom: triggeredFrom
            }));
        }
        return renderRestrictionsButton(dialogStateContainer);
    };
    const renderGrantAccessFlagAndButton = (dialogStateContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, renderRestrictionsButton(dialogStateContainer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8RR7m.GrantAccessFlagLoader), {
            contentId: contentId
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $0b24ce56d1d6b617$var$buttonContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
            isCustomStart: true,
            key: `start-${contentId}`,
            metric: (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
        }), edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams })=>{
            const { accountId: accountId, grantAccess: grantAccess, username: // TODO(brizvash): non-gdpr params, remove when GDPR is on
            username } = getQueryParams();
            const shouldShowGrantAccessDialog = Boolean(grantAccess && accountId || username);
            const renderGrantAccessComponent = ()=>(0, $9wGTI.fg)('confluence_frontend_grant_access_flag') ? renderGrantAccessFlagAndButton(dialogStateContainer) : renderGrantAccessDialogAndButton(getQueryParams, dialogStateContainer, shouldShowGrantAccessDialog);
            return edition === (0, $euL71.ConfluenceEdition).FREE ? renderFreeEditionDialog(dialogStateContainer, shouldShowGrantAccessDialog) : renderGrantAccessComponent();
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fkOJz.RestrictionsButtonLoading), null)));
});
$0b24ce56d1d6b617$export$4a978df01c3bf89e.displayName = 'RestrictionsDialogTrigger';
function $0b24ce56d1d6b617$export$59974e42a4613c7({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, dialogStateContainer: dialogStateContainer, edition: edition, experienceTracker: experienceTracker, triggeredFrom: triggeredFrom, contentType: contentType, contentSubType: contentSubType, contentId: contentId }) {
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            source: 'viewPageScreen',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                source: 'v2',
                triggeredFrom: triggeredFrom,
                edition: edition,
                contentType: contentType,
                isLivePage: contentSubType === 'live'
            }
        }
    }).fire();
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_EXPERIENCE),
        attributes: {
            contentType: contentType
        },
        collect (events, experience) {
            // Fail/Abort RESTRICTIONS_DIALOG as soon as _LOAD or _APPLY fails or aborts:
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskFail' || action === 'taskAbort') && (name === (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE) || name === (0, $irVI7.RESTRICTIONS_DIALOG_APPLY_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    //
    // Open RestrictionsDialog:
    //
    dialogStateContainer.setContentId(contentId);
    dialogStateContainer.setIsOpen(true, triggeredFrom);
    (0, $14SPd.RESTRICTIONS_DIALOG_METRIC).start();
}

});
parcelRegister("5u6LZ", function(module, exports) {

$parcel$export(module.exports, "GrantAccessDialogLoader", () => $11d9bf397902be9d$export$238288686fd365c4);
/**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");

var $eZFA1 = parcelRequire("eZFA1");

const $11d9bf397902be9d$export$cc070c4b76bfe85d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "5ag_g",
    name: "GrantAccessDialogPaint",
    loader: async ()=>(await (parcelRequire("glj0O"))).GrantAccessDialog
});

const $11d9bf397902be9d$export$238288686fd365c4 = ({ contentId: contentId, accountId: accountId, shouldSSRGrantAccessRestrictions: shouldSSRGrantAccessRestrictions, buttonPlaceholder: buttonPlaceholder, ...props })=>{
    const GrantAccessDialog = (0, $jmjWc.LoadableLazy)({
        __loadable_id__: "o997N",
        name: "GrantAccessDialog",
        loader: async ()=>(await (parcelRequire("glj0O"))).GrantAccessDialog,
        loading: ()=>buttonPlaceholder
    });
    const shouldPreloadGrantAccess = shouldSSRGrantAccessRestrictions && window.__SSR_RENDERED__;
    const { data: data, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $eZFA1.GrantAccessDialogLoaderQuery), {
        variables: {
            contentId: contentId || '',
            accountId: accountId
        },
        skip: !contentId || !accountId,
        fetchPolicy: shouldPreloadGrantAccess ? 'cache-first' : 'cache-and-network'
    });
    let profilePhoto = '';
    const photos = data?.user?.photos;
    if (photos?.length) {
        const primary = photos.find((photo)=>photo?.isPrimary);
        const foundPhoto = primary ? primary.value : photos[0]?.value;
        profilePhoto = foundPhoto || '';
    }
    const Component = shouldSSRGrantAccessRestrictions ? $11d9bf397902be9d$export$cc070c4b76bfe85d : GrantAccessDialog;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    });
    else if (!contentId || !data?.user) // If user is not recognized or we have no target contentId, render just the children.
    // User is identified via URL params and it would be easy to pass invalid data.
    // Note: must render the children, as this is how restrictions button is displayed
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
        contentId: contentId,
        accountId: accountId,
        contentTitle: data?.singleContent?.title || '',
        displayName: data?.user?.displayName || '',
        profilePhoto: profilePhoto,
        ...props
    });
};

});
parcelRegister("glj0O", function(module, exports) {

let $be5d5ae9ce9637c0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $be5d5ae9ce9637c0$var$load("1Qnbq"),
    $be5d5ae9ce9637c0$var$load("aZinD"),
    $be5d5ae9ce9637c0$var$load("h4Nf7"),
    $be5d5ae9ce9637c0$var$load("fqZPY"),
    $be5d5ae9ce9637c0$var$load("9ybBP"),
    $be5d5ae9ce9637c0$var$load("c6MKV"),
    $be5d5ae9ce9637c0$var$load("ffEVr"),
    $be5d5ae9ce9637c0$var$load("joJy8"),
    $be5d5ae9ce9637c0$var$load("aHE9G"),
    $be5d5ae9ce9637c0$var$load("9PeA0")
]).then(()=>parcelRequire('3aGPB'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});




parcelRegister("8RR7m", function(module, exports) {

$parcel$export(module.exports, "GrantAccessFlagLoader", () => $1756d5d44ec15fad$export$a83249587a24be5);

var $jmjWc = parcelRequire("jmjWc");

const $1756d5d44ec15fad$export$a83249587a24be5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "960Da",
    name: "GrantAccessFlagLoader",
    loader: async ()=>(await (parcelRequire("5NOVJ"))).GrantAccessFlag
});

});
parcelRegister("5NOVJ", function(module, exports) {

let $439908ff173c2fd9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $439908ff173c2fd9$var$load("aZinD"),
    $439908ff173c2fd9$var$load("h4Nf7"),
    $439908ff173c2fd9$var$load("fqZPY"),
    $439908ff173c2fd9$var$load("9ybBP"),
    $439908ff173c2fd9$var$load("c6MKV"),
    $439908ff173c2fd9$var$load("ffEVr"),
    $439908ff173c2fd9$var$load("joJy8"),
    $439908ff173c2fd9$var$load("aHE9G"),
    $439908ff173c2fd9$var$load("4mWJk")
]).then(()=>parcelRequire('4Cd45'));

});


parcelRegister("cSVAY", function(module, exports) {

$parcel$export(module.exports, "RestrictionsButtonLoaderPaint", () => $c09757da0c891efc$export$758fc7bfe6cba448);
$parcel$export(module.exports, "RestrictionsButtonLoaderAfterPaint", () => $c09757da0c891efc$export$92f59ae572209281);

var $jmjWc = parcelRequire("jmjWc");

var $eE3dj = parcelRequire("eE3dj");

var $fkOJz = parcelRequire("fkOJz");

const $c09757da0c891efc$export$758fc7bfe6cba448 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "langk",
    name: "RestrictionsButtonLoaderPaint",
    loader: async ()=>(await (parcelRequire("bhei5"))).RestrictionsButton,
    loading: (0, $fkOJz.RestrictionsButtonLoading)
});

const $c09757da0c891efc$export$92f59ae572209281 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZXc7l",
    name: "RestrictionsButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("bhei5"))).RestrictionsButton,
    loading: (0, $eE3dj.RestrictionsButtonPlaceholder)
});

});
parcelRegister("eE3dj", function(module, exports) {

$parcel$export(module.exports, "RestrictionsButtonPlaceholder", () => $cb1652ec96a3881c$export$f7c9f842c83767d4);

var $gwFzn = parcelRequire("gwFzn");
function $cb1652ec96a3881c$export$f7c9f842c83767d4() {
    // The RestrictionsDialog will be positioned based on the initial dimensions of
    // RestrictionsButton, so we need to render a placeholder instead of `null`
    // This placeholder is also used in SSR.
    // All the place that is waiting for data in restrictions package should use this placeholder instead of null.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "restrictions-button-placeholder",
        "data-test-id": "restrictions-button-placeholder",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 32,
            height: 32
        }
    });
}

});

parcelRegister("fkOJz", function(module, exports) {

$parcel$export(module.exports, "RestrictionsButtonLoading", () => $560660f3777cb1ae$export$3375d726052961a6);

var $gwFzn = parcelRequire("gwFzn");

var $j8UzL = parcelRequire("j8UzL");

var $eE3dj = parcelRequire("eE3dj");
const $560660f3777cb1ae$var$checkForSSRRestrictionsButtonClicked = ()=>{
    return Boolean(window.__SSR_EVENTS_CAPTURE__?.restrictionsButton);
};
const $560660f3777cb1ae$export$3375d726052961a6 = ()=>{
    return $560660f3777cb1ae$var$checkForSSRRestrictionsButtonClicked() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j8UzL.SSRActionLoadingSpinner), {
        spinnerId: "restrictions-loading-spinner",
        actionType: "restrictionsButton"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
};

});

parcelRegister("bhei5", function(module, exports) {

let $835c5e0f6c88611c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $835c5e0f6c88611c$var$load("ffEVr"),
    $835c5e0f6c88611c$var$load("bfhXH")
]).then(()=>parcelRequire('l5Yc7'));

});




parcelRegister("lQDcS", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDialogMenuPropsProvider", () => $3b0d5969bb769929$export$b0eaba4fdbbe6e8b);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $ipPpS = parcelRequire("ipPpS");

var $inPa6 = parcelRequire("inPa6");

var $1kHsc = parcelRequire("1kHsc");

var $bVAxT = parcelRequire("bVAxT");

var $bQm3c = parcelRequire("bQm3c");

var $lEXFh = parcelRequire("lEXFh");
const $3b0d5969bb769929$var$label = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
    id: "restrictions.dialog.link.text",
    defaultMessage: "Restrictions"
});
function $3b0d5969bb769929$export$b0eaba4fdbbe6e8b({ children: children, contentId: contentId }) {
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // Note: this is used for balance A/B testing user cohorts, it will be replaced with real feature flag later.
    return children && edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer)=>children({
            id: 'bm-restrictions-link',
            label: $3b0d5969bb769929$var$label,
            onClick () {
                (0, $lEXFh.startRestrictionsDialogExperience)({
                    ...useAnalyticsEventsHook,
                    actionSubjectId: 'restrictionsDialogLink',
                    dialogStateContainer: dialogStateContainer,
                    edition: edition,
                    experienceTracker: experienceTracker,
                    triggeredFrom: 'actionsMenu',
                    contentId: contentId
                });
            }
        })) : null;
}

});

parcelRegister("6gsgG", function(module, exports) {

let $48fa2a260a7bb130$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $48fa2a260a7bb130$var$load("joJy8"),
    $48fa2a260a7bb130$var$load("aHE9G"),
    $48fa2a260a7bb130$var$load("fno6o")
]).then(()=>parcelRequire('ca7si'));

});


var $cddca172c04d6e20$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"2Qrvo\",\"QuickActionsContent.579d88b7.js\",\"fno6o\",\"RestrictionsDialogMountPoint.740bdaa4.js\",\"inQqk\",\"RestrictionsDialog.e9acd9a1.js\",\"dGk3x\",\"GlobalFeedbackCollector.5c3e76a5.js\",\"aHE9G\",\"vendors~editor_atlaskit.fa38c7b3.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.c6bf66de.js\",\"ffEVr\",\"vendors~editor_icon.92bb159e.js\",\"cyGuT\",\"feedback-collector.b1919a90.js\",\"aHE9G\",\"vendors~editor_atlaskit.fa38c7b3.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.c6bf66de.js\",\"aZinD\",\"vendors.0386fed2.js\",\"c6MKV\",\"stable_vendors.1dfa4f36.js\",\"aZinD\",\"vendors.0386fed2.js\",\"c6MKV\",\"stable_vendors.1dfa4f36.js\",\"iPz8n\",\"GlobalFeedbackCollector.d8df6b85.js\",\"1RolH\",\"EmojiPickerComponent.33a787e5.js\",\"etwBB\",\"activity.d3402161.js\",\"a2rZD\",\"custom.fc3cd725.js\",\"ePm95\",\"flags.40431f78.js\",\"kJcWg\",\"food.473b199a.js\",\"cUIjD\",\"frequent.67753c39.js\",\"4tIwu\",\"nature.96f73db7.js\",\"1sEV4\",\"objects.ee88e397.js\",\"6Tafs\",\"people.9a055314.js\",\"6j8nK\",\"symbols.fdc6ed64.js\",\"i1sL7\",\"travel.5460db1e.js\",\"36ctu\",\"productivity.bb738ebf.js\",\"bEnB5\",\"modal.74fde4f3.js\",\"fhU7k\",\"esm.50a6c5c3.js\",\"4hOv8\",\"esm.bc27d7ff.js\",\"gg6T0\",\"modal.e56b33bc.js\",\"6aruy\",\"media-client-react.88ecf091.js\",\"fsZ6i\",\"media-client-react.6ee34dde.js\",\"4Bp5z\",\"ReadTimePopup.3c029061.js\",\"jWyan\",\"angle-brackets-icon.0108617d.js\",\"4M7W5\",\"mediaInlineCard.11bd096a.js\",\"jDjSj\",\"16.8a4cce0e.js\",\"8059b\",\"16.afe6487f.js\",\"hPalR\",\"16.93dce164.js\",\"2fk6g\",\"16.bea78523.js\",\"dil5i\",\"24.e2acaae5.js\",\"eYDcz\",\"modal.0d3f7674.js\",\"fYhfO\",\"modal.4e87ffc8.js\",\"iIRyn\",\"modal.runtime.fd384371.js\",\"iIRyn\",\"modal.runtime.fd384371.js\",\"iP5Bv\",\"mediaInlineAnalyticsErrorBoundary.da71b2bb.js\",\"fwuXj\",\"cardWithMediaClient.317dad77.js\",\"8Ozg8\",\"inlinePlayer.7538d68b.js\",\"cXPC0\",\"EmbedModal.a727c385.js\",\"dUKeO\",\"vid-full-screen-on.89bfbdcb.js\",\"iiqDR\",\"vid-full-screen-off.edfa2cde.js\",\"5rLJa\",\"vid-pause.b74a9dab.js\",\"eILYA\",\"LinkCards.4a9a2a5a.js\",\"6dDCB\",\"outgoing-sound.ec5fde53.js\",\"2Mhbz\",\"cardWithMediaClient.28ad5b7a.js\",\"h9Mrx\",\"video.6b53aa5b.js\",\"1Qnbq\",\"ReadTimePopup.52bfd6e2.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.c6bf66de.js\",\"8DoxJ\",\"modal.3fd9f746.js\",\"P5iE2\",\"24.874d8c90.js\",\"42vdC\",\"24.4866b870.js\",\"9Bu2S\",\"24.1eba1b1c.js\",\"8pE8S\",\"24.4b97cbb2.js\",\"ivQYH\",\"24.272a2b94.js\",\"7a9CL\",\"24.f46d75b2.js\",\"8mzoy\",\"24.b3fbae03.js\",\"bjzRn\",\"24.44a1e682.js\",\"fYi1a\",\"24.8dbe60cd.js\",\"fqrMn\",\"24.60e4661d.js\",\"hzK1f\",\"24.98083536.js\",\"e53Dv\",\"vid-play.9e8ddef6.js\",\"6gqpV\",\"GlobalFeedbackCollector.493c1808.js\",\"5doAZ\",\"DatePicker.fc4d895a.js\",\"9KJWc\",\"clipboard.256435a8.js\",\"1qUWs\",\"media-viewer-error-boundary.445b2080.js\",\"7Vmxp\",\"table.f8779bf1.js\",\"h9hWQ\",\"SimpleEmoji.0213c7c9.js\",\"eFHVS\",\"extensibility.bc55036e.js\",\"djfev\",\"ConfigPanelFieldsLoader.88dae015.js\",\"6FRhD\",\"modal.d7e76543.js\",\"hP2ev\",\"modal.runtime.046de774.js\",\"eoIpr\",\"add-circle.bdecb931.js\",\"hP2ev\",\"modal.runtime.046de774.js\",\"9p2N9\",\"ui.2a29b85d.js\",\"cCWZm\",\"dropzone.a0930126.js\",\"lE3cg\",\"media-picker-analytics-error-boundary.522e0176.js\",\"cKkZK\",\"media-viewer-error-boundary.8610fd88.js\",\"bHwQq\",\"archive.fd275619.js\",\"9vSeI\",\"audio.7b721c3b.js\",\"8PuzS\",\"archive.29f79635.js\",\"lixGB\",\"78-EUC-H.51d0c3f9.js\",\"fH2pk\",\"78-EUC-V.64ff1cfd.js\",\"kZB45\",\"78-H.0ed13b16.js\",\"6BxSI\",\"78-RKSJ-H.dc86b34e.js\",\"i9zPw\",\"78-RKSJ-V.82830549.js\",\"8Qq8X\",\"78-V.b650b3b6.js\",\"hUHQJ\",\"78ms-RKSJ-H.8d99de38.js\",\"4Y4SR\",\"78ms-RKSJ-V.d9f17393.js\",\"axQaS\",\"83pv-RKSJ-H.f8767ab6.js\",\"hh6Ks\",\"90ms-RKSJ-H.d832d6a6.js\",\"gyPUO\",\"90ms-RKSJ-V.260dbffb.js\",\"aduQJ\",\"90msp-RKSJ-H.364f2808.js\",\"3iFld\",\"90msp-RKSJ-V.aa85de80.js\",\"6XUCn\",\"90pv-RKSJ-H.848d9bac.js\",\"8eJG6\",\"90pv-RKSJ-V.92513b15.js\",\"iveJ5\",\"Add-H.729159c7.js\",\"kOqxj\",\"Add-RKSJ-H.2baf4c23.js\",\"1zYOj\",\"Add-RKSJ-V.24c188d0.js\",\"2MU2T\",\"Add-V.f276585e.js\",\"oH9eX\",\"Adobe-CNS1-0.c94fb46d.js\",\"fSa6m\",\"Adobe-CNS1-1.22c8a053.js\",\"g2oEO\",\"Adobe-CNS1-2.b6e41c65.js\",\"8WzHR\",\"Adobe-CNS1-3.6168987e.js\",\"ca0bh\",\"Adobe-CNS1-4.44238a8c.js\",\"cfcpu\",\"Adobe-CNS1-5.62d26997.js\",\"li5lK\",\"Adobe-CNS1-6.7ebee211.js\",\"kujwR\",\"Adobe-CNS1-UCS2.0dd5c8ce.js\",\"8iFzj\",\"Adobe-GB1-0.249f5de6.js\",\"6D5co\",\"Adobe-GB1-1.74dabbbf.js\",\"cfFSd\",\"Adobe-GB1-2.4a68d0c8.js\",\"exff1\",\"Adobe-GB1-3.b5b05f5d.js\",\"aeuVs\",\"Adobe-GB1-4.c9dd9584.js\",\"aLrjO\",\"Adobe-GB1-5.0e92a2eb.js\",\"j3PYN\",\"Adobe-GB1-UCS2.bb70ebea.js\",\"d0uYO\",\"Adobe-Japan1-0.4d890a6e.js\",\"eEcvV\",\"Adobe-Japan1-1.a0781bed.js\",\"820v9\",\"Adobe-Japan1-2.9f2dc797.js\",\"frVgA\",\"Adobe-Japan1-3.15951cff.js\",\"jdQzX\",\"Adobe-Japan1-4.0cfae895.js\",\"Z8yoS\",\"Adobe-Japan1-5.66dd1b5b.js\",\"k2vqy\",\"Adobe-Japan1-6.7e06fceb.js\",\"kgt4y\",\"Adobe-Japan1-UCS2.e121ba74.js\",\"eP0RM\",\"Adobe-Korea1-0.ab6029ff.js\",\"gA5f7\",\"Adobe-Korea1-1.f58d7af7.js\",\"i4Ed8\",\"Adobe-Korea1-2.90e46d21.js\",\"l6X7m\",\"Adobe-Korea1-UCS2.37651d5b.js\",\"aphLF\",\"B5-H.35e26a2d.js\",\"7EoeH\",\"B5-V.af3f0204.js\",\"6Q7ZY\",\"B5pc-H.e4f1d7a8.js\",\"8cnq9\",\"B5pc-V.8f5377c3.js\",\"7NcV5\",\"CNS-EUC-H.6bb831b5.js\",\"cxpt9\",\"CNS-EUC-V.8c378414.js\",\"l27ve\",\"CNS1-H.ea7d046f.js\",\"c6rCW\",\"CNS1-V.1fdf3e4e.js\",\"3upsV\",\"CNS2-H.705fd9e8.js\",\"k9G9k\",\"CNS2-V.c55f4d63.js\",\"bDgpL\",\"ETHK-B5-H.7f8e45d5.js\",\"33eqd\",\"ETHK-B5-V.09bf3c22.js\",\"5F3PA\",\"ETen-B5-H.05fb1408.js\",\"hfiT2\",\"ETen-B5-V.5e380c42.js\",\"jMuj8\",\"ETenms-B5-H.3891364b.js\",\"gNTCu\",\"ETenms-B5-V.394705ca.js\",\"6rTQb\",\"EUC-H.b991c232.js\",\"l89SH\",\"EUC-V.0ac4677e.js\",\"iEkij\",\"Ext-H.5968bae5.js\",\"eVVKx\",\"Ext-RKSJ-H.d9938a5e.js\",\"kL3q4\",\"Ext-RKSJ-V.e9a51cbe.js\",\"avDfo\",\"Ext-V.74d1f996.js\",\"l3LgN\",\"GB-EUC-H.910bba6d.js\",\"eIBS8\",\"GB-EUC-V.0c6edfac.js\",\"8HXb3\",\"GB-H.92bed904.js\",\"lWK2A\",\"GB-V.4564569a.js\",\"iYIwI\",\"GBK-EUC-H.f5f68a8f.js\",\"g4Lp1\",\"GBK-EUC-V.97682197.js\",\"9jlRI\",\"GBK2K-H.edc4a051.js\",\"g2IgM\",\"GBK2K-V.46c62554.js\",\"24SBU\",\"GBKp-EUC-H.da565c58.js\",\"gzU5W\",\"GBKp-EUC-V.d5927fe2.js\",\"jN4tb\",\"GBT-EUC-H.267ac8c0.js\",\"6fVUl\",\"GBT-EUC-V.7720b25f.js\",\"e0AMV\",\"GBT-H.974fe797.js\",\"htjXf\",\"GBT-V.12defd7a.js\",\"hWeIU\",\"GBTpc-EUC-H.43d524d7.js\",\"1eaMl\",\"GBTpc-EUC-V.c77ba0fc.js\",\"fDvqM\",\"GBpc-EUC-H.08408830.js\",\"2de5A\",\"GBpc-EUC-V.ddbe12a3.js\",\"19tEv\",\"H.8a76eaa0.js\",\"j0hRA\",\"HKdla-B5-H.e6a4bedb.js\",\"fd9qd\",\"HKdla-B5-V.94816590.js\",\"e9cdN\",\"HKdlb-B5-H.41238054.js\",\"aNHZK\",\"HKdlb-B5-V.c7a56f0d.js\",\"hgC4a\",\"HKgccs-B5-H.423aefeb.js\",\"eEaBv\",\"HKgccs-B5-V.fff775c8.js\",\"fYV0G\",\"HKm314-B5-H.60d4b9bb.js\",\"dJs80\",\"HKm314-B5-V.997bace9.js\",\"4Y1kq\",\"HKm471-B5-H.0a6f2053.js\",\"hYpsA\",\"HKm471-B5-V.5588cb3b.js\",\"9xkOt\",\"HKscs-B5-H.cbf6db19.js\",\"lm69C\",\"HKscs-B5-V.cf9a31dc.js\",\"kva4v\",\"Hankaku.ca0ba78b.js\",\"5AfTB\",\"Hiragana.85378b4a.js\",\"3TaY6\",\"KSC-EUC-H.aff5022e.js\",\"8wf7j\",\"KSC-EUC-V.3949c72d.js\",\"cgHyF\",\"KSC-H.4ed431c9.js\",\"cxq0E\",\"KSC-Johab-H.22d6dfec.js\",\"ipw37\",\"KSC-Johab-V.0ee59f70.js\",\"aD76K\",\"KSC-V.dc2b8859.js\",\"8okaY\",\"KSCms-UHC-H.b54f6070.js\",\"i7fxp\",\"KSCms-UHC-HW-H.998acbf6.js\",\"7fYMC\",\"KSCms-UHC-HW-V.0a3c59db.js\",\"imOx6\",\"KSCms-UHC-V.37c6be44.js\",\"gKF8I\",\"KSCpc-EUC-H.4cfc83d8.js\",\"9m5PS\",\"KSCpc-EUC-V.5881e143.js\",\"8asvD\",\"Katakana.321c2f5f.js\",\"7HkN3\",\"NWP-H.6a69fa60.js\",\"isnju\",\"NWP-V.88613bd5.js\",\"f31m2\",\"RKSJ-H.2af2abd8.js\",\"2VYvR\",\"RKSJ-V.65a07798.js\",\"1KF3Q\",\"Roman.ca13d8f3.js\",\"29QIq\",\"UniCNS-UCS2-H.f2596cac.js\",\"dVqyh\",\"UniCNS-UCS2-V.4be9430a.js\",\"7UKDA\",\"UniCNS-UTF16-H.bb71adc5.js\",\"Q9KG4\",\"UniCNS-UTF16-V.d89c4950.js\",\"c2z6B\",\"UniCNS-UTF32-H.6ef36f87.js\",\"lTznr\",\"UniCNS-UTF32-V.c838593e.js\",\"7t7V6\",\"UniCNS-UTF8-H.77d5771f.js\",\"lcMXU\",\"UniCNS-UTF8-V.70a7ba9f.js\",\"4Y11P\",\"UniGB-UCS2-H.1303e3c8.js\",\"6MnqR\",\"UniGB-UCS2-V.c4668ab1.js\",\"eQt1R\",\"UniGB-UTF16-H.d1be3be2.js\",\"fm8Lw\",\"UniGB-UTF16-V.a072ba07.js\",\"4l8L7\",\"UniGB-UTF32-H.e2d1c79f.js\",\"1tDis\",\"UniGB-UTF32-V.76c200be.js\",\"2Vv5T\",\"UniGB-UTF8-H.41f4baba.js\",\"iWa77\",\"UniGB-UTF8-V.8ed42052.js\",\"38Eab\",\"UniJIS-UCS2-H.e0c99f94.js\",\"lDeVy\",\"UniJIS-UCS2-HW-H.2086623a.js\",\"8aWy7\",\"UniJIS-UCS2-HW-V.ffb2caeb.js\",\"76QHL\",\"UniJIS-UCS2-V.21ffe4a5.js\",\"lRW10\",\"UniJIS-UTF16-H.4216604d.js\",\"aJpvy\",\"UniJIS-UTF16-V.48b4e738.js\",\"7s6rx\",\"UniJIS-UTF32-H.038159ea.js\",\"jUs4H\",\"UniJIS-UTF32-V.34681c47.js\",\"a8YIF\",\"UniJIS-UTF8-H.3f187918.js\",\"fH9Jk\",\"UniJIS-UTF8-V.dd6be6a0.js\",\"13MuZ\",\"UniJIS2004-UTF16-H.c4a60299.js\",\"hwfXT\",\"UniJIS2004-UTF16-V.2dbaf4f4.js\",\"dGSeC\",\"UniJIS2004-UTF32-H.dba66596.js\",\"9rrYA\",\"UniJIS2004-UTF32-V.74761cad.js\",\"7d1OI\",\"UniJIS2004-UTF8-H.4ec8549f.js\",\"809oM\",\"UniJIS2004-UTF8-V.c5cc5b20.js\",\"bdrR8\",\"UniJISPro-UCS2-HW-V.4031e777.js\",\"4D2EW\",\"UniJISPro-UCS2-V.5072efde.js\",\"cdY8a\",\"UniJISPro-UTF8-V.7adee45d.js\",\"avqzB\",\"UniJISX0213-UTF32-H.56363b94.js\",\"j845q\",\"UniJISX0213-UTF32-V.6e415ebf.js\",\"emImx\",\"UniJISX02132004-UTF32-H.80a3d411.js\",\"f6AOW\",\"UniJISX02132004-UTF32-V.75e044a9.js\",\"7pSug\",\"UniKS-UCS2-H.4ff5f169.js\",\"465mT\",\"UniKS-UCS2-V.af99e23d.js\",\"3w6Hd\",\"UniKS-UTF16-H.b031c3f9.js\",\"4T3rW\",\"UniKS-UTF16-V.dbaec3f8.js\",\"d8Hqs\",\"UniKS-UTF32-H.11f34035.js\",\"77ADK\",\"UniKS-UTF32-V.344d4ef0.js\",\"dkDCu\",\"UniKS-UTF8-H.a4bf67c4.js\",\"8Qdf7\",\"UniKS-UTF8-V.af9521f3.js\",\"bhNwf\",\"V.5ce814bb.js\",\"ioEN1\",\"WP-Symbol.9e3226a6.js\",\"edP6u\",\"home.9c6d2e67.js\",\"2OhRQ\",\"codeViewerRenderer.29c899a3.js\",\"3wpjh\",\"image.4dcab477.js\",\"869mA\",\"video.f359eb55.js\",\"j7Vtd\",\"audio.b8a5bcaa.js\",\"f33Ay\",\"doc.c719a94c.js\",\"2JEgu\",\"codeViewer.50fd71a1.js\",\"93dCk\",\"codeViewer.71b6c0bb.js\",\"01BDc\",\"dist.f36f7d00.js\",\"jneCP\",\"dist.adf4c603.js\",\"7sleH\",\"dist.21a5cb52.js\",\"3lBx7\",\"dist.82105929.js\",\"1EgQg\",\"dist.7c7ec582.js\",\"iWiJK\",\"dist.03768f8e.js\",\"gkT8b\",\"dist.11d30e66.js\",\"lLY5F\",\"dist.521fa1db.js\",\"7BCTg\",\"dist.daadd8cb.js\",\"jD4Pj\",\"dist.0c350558.js\",\"217bQ\",\"dist.563e7eec.js\",\"3AIgh\",\"dist.a75fea7a.js\",\"3WBDc\",\"dist.b344a93f.js\",\"gnPOt\",\"dist.761f9dfc.js\",\"73p2H\",\"dist.0397e21f.js\",\"22pEl\",\"dist.8b39c40c.js\",\"cgrQ3\",\"dist.a04ab887.js\",\"5BOC6\",\"dist.30663d49.js\",\"b3fvV\",\"dist.37416658.js\",\"ajqM4\",\"dist.9ab582a8.js\",\"jjPUS\",\"apl.b81e50f9.js\",\"h9FOd\",\"asciiarmor.8042d41d.js\",\"aCljb\",\"asn1.a9aaf8f7.js\",\"lE1F7\",\"asterisk.f4595367.js\",\"aXFnX\",\"brainfuck.4bd8ce2f.js\",\"gkO56\",\"cobol.30d0d372.js\",\"aXQyM\",\"clike.34bb1d46.js\",\"diAFJ\",\"clojure.21077391.js\",\"d7yTx\",\"css.3d1ff96e.js\",\"b2YDT\",\"cmake.0e3e455b.js\",\"4ga7U\",\"coffeescript.c2281a85.js\",\"cZ3D7\",\"commonlisp.97a06575.js\",\"qaaCs\",\"cypher.b80fd281.js\",\"9Fcz0\",\"python.f5111821.js\",\"6RZjl\",\"crystal.a0197265.js\",\"ji1Kk\",\"d.42c2683e.js\",\"2L5Mz\",\"diff.cdb11d67.js\",\"lmz4e\",\"dockerfile.70f43558.js\",\"814bh\",\"dtd.11778cc2.js\",\"7XVNh\",\"dylan.468e767f.js\",\"hGS6V\",\"ebnf.30d80091.js\",\"592ir\",\"ecl.5a273c1a.js\",\"hPiIc\",\"eiffel.85a912d8.js\",\"7wfVk\",\"elm.77c03e04.js\",\"ebMo8\",\"erlang.6dc9b335.js\",\"5h0BU\",\"sql.83903d9f.js\",\"bE4uu\",\"factor.91d4bca2.js\",\"7Mgt2\",\"fcl.8ab4c522.js\",\"bOI1J\",\"forth.3c528cb4.js\",\"bmWQh\",\"fortran.e0029ed4.js\",\"kHxTh\",\"mllike.153cf519.js\",\"6MC1n\",\"gas.a7bccbc7.js\",\"lNBbh\",\"gherkin.3957c5fc.js\",\"bYMjO\",\"groovy.2c7c6877.js\",\"kIBZl\",\"haskell.27501ac4.js\",\"3uMSv\",\"haxe.54a5898e.js\",\"9vuGq\",\"http.bc2057b4.js\",\"1eHix\",\"idl.b9661b63.js\",\"7kn4A\",\"javascript.398b6ea8.js\",\"j4qEZ\",\"jinja2.a602283d.js\",\"3ozoR\",\"julia.eb339e67.js\",\"3DTzS\",\"livescript.a061dc12.js\",\"hURlP\",\"lua.1771bd2a.js\",\"2gQjS\",\"mirc.df514b63.js\",\"hoU9b\",\"mathematica.4b8aab4c.js\",\"40pAI\",\"modelica.f8eb4cea.js\",\"i5YKF\",\"mumps.cf82c6f0.js\",\"hIeWi\",\"mbox.e4169567.js\",\"8q3KK\",\"nginx.5d266b03.js\",\"1VXLT\",\"nsis.e4e191fa.js\",\"bAq00\",\"ntriples.12b53fef.js\",\"aEtpl\",\"octave.05b71169.js\",\"hfTKk\",\"oz.0938f362.js\",\"hTqBJ\",\"pascal.39d89476.js\",\"5ukWe\",\"perl.52765d5b.js\",\"3XLd5\",\"pig.0fb008c2.js\",\"2QavN\",\"powershell.f53ac67c.js\",\"ch01A\",\"properties.ff60ea69.js\",\"7inaT\",\"protobuf.c983d409.js\",\"cJ7mc\",\"pug.9abece4a.js\",\"5NvMz\",\"puppet.b9ab89df.js\",\"ego66\",\"q.aaa15180.js\",\"hj2Rh\",\"r.0b08b779.js\",\"b7tzx\",\"rpm.685318b2.js\",\"3YkAH\",\"ruby.04bb2af8.js\",\"cf92i\",\"sas.9ff0311d.js\",\"8W2eu\",\"scheme.a36ef94c.js\",\"lcrbq\",\"shell.d5f15f17.js\",\"98Pr8\",\"sieve.f0f2cb2c.js\",\"9dDWH\",\"smalltalk.33729233.js\",\"lrUqt\",\"solr.21ea773c.js\",\"bfOqz\",\"sparql.554ff633.js\",\"glXdM\",\"spreadsheet.cd8b4101.js\",\"b9USS\",\"stylus.7e0a4e39.js\",\"kPthK\",\"swift.633d1fa8.js\",\"jsCJL\",\"stex.8d5212f6.js\",\"abYjx\",\"verilog.d22265d7.js\",\"d7Hao\",\"tcl.ced1f258.js\",\"axn6R\",\"textile.51355a0b.js\",\"jDwZc\",\"tiddlywiki.5e83d78f.js\",\"ejPOn\",\"tiki.6fb365f5.js\",\"jx5LN\",\"toml.84dc3c91.js\",\"lsrGy\",\"troff.f7dd2860.js\",\"caKW9\",\"ttcn.4a33ec37.js\",\"6cyuP\",\"ttcn-cfg.5ae2f58f.js\",\"kezEf\",\"turtle.ed16c466.js\",\"ec2k9\",\"webidl.32e06ad6.js\",\"gQivI\",\"vb.278bc558.js\",\"1MGG6\",\"vbscript.a342aecd.js\",\"19BgE\",\"velocity.40adbcac.js\",\"4QVhK\",\"vhdl.7cdb96b8.js\",\"5PTeQ\",\"xquery.27819ab6.js\",\"7rV3v\",\"yacas.6d63ee7e.js\",\"lzeGI\",\"z80.2e6d4d2e.js\",\"jZHIh\",\"mscgen.5ea5176c.js\",\"hLKFT\",\"dist.a9b48aa5.js\",\"4ZwHa\",\"dist.83c91e9c.js\",\"gQYJt\",\"svg.0f44db18.js\",\"gFHfi\",\"zoom-out.db09cd7a.js\",\"4uhcp\",\"zoom-in.5852ad10.js\",\"doomh\",\"chevron-left-circle.db11b726.js\",\"bbnaa\",\"GlobalFeedbackCollector.086787aa.js\",\"8Khwy\",\"GlobalFeedbackCollector.7c1b47d5.js\",\"lnCW7\",\"ExternalCollaboratorInSpaceNotify.0768fceb.js\",\"j02A7\",\"ViewExternalCollaboratorsLink.aaaf4419.js\",\"l5XQ1\",\"ViewSpaceExternalCollaboratorsDialog.131ddef7.js\",\"5joXW\",\"GuestRequestToUpgradeToUser.7da96066.js\",\"1epse\",\"GuestRequestToUpgradeLearnMoreModal.443ac364.js\",\"8Txex\",\"Guest-Avatar.ebdf69f1.svg\",\"2wyTK\",\"Team-Avatars.4f1b07ad.svg\",\"h4Nf7\",\"ExternalUserLozenge.546379e0.js\",\"aHE9G\",\"vendors~editor_atlaskit.fa38c7b3.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.c6bf66de.js\",\"3wN5D\",\"ExternalSpaceLozenge.6d51a964.js\",\"j3iEF\",\"CommentAddPromptNudgeText.5f1b8fa4.js\",\"lwUFR\",\"RequestAccessForUnassignedGuest.9a35b3a7.js\",\"aad5M\",\"Collaboration-Bike.8735a1c6.svg\",\"7Ni3R\",\"GuestOnboardingModal.88285666.js\",\"WYAWv\",\"Guest-Onboarding-Light.8e788fbd.svg\",\"4rpM2\",\"Guest-Onboarding-Dark.f055cab3.svg\",\"hA2SB\",\"GroupAndUserItem.63b46522.js\",\"hwiu3\",\"NavigationLockout.6ac66ad3.js\",\"iHlO3\",\"empty-filter.16dda5ac.svg\",\"3XMOA\",\"modal.09301316.js\",\"9LX74\",\"searchNoResults.7be90ed3.svg\",\"bU3dV\",\"CopySpacePermissionsAndDefaultPermissions.62693001.js\",\"ktyyJ\",\"TrialFlags.29e967aa.js\",\"cmcKh\",\"TrialFlags.0d9edc2f.js\",\"4yUSc\",\"PremiumLozenge.1ef1822e.js\",\"ePA5l\",\"Lozenge.156d3474.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"fqBFU\",\"ReverseTrialLozenge.93dcc19b.js\",\"1HAEl\",\"ReverseTrialListItem.37c62263.js\",\"kPQBd\",\"CompletionFlag.d73c19f6.js\",\"dA1E5\",\"ShareButton.12b748cc.js\",\"9ybBP\",\"mention.2bf41d36.js\",\"fqZPY\",\"mention.runtime.9c1ade46.js\",\"ftJgg\",\"ShareButton.f5289ded.js\",\"j4POW\",\"GroupAndUserItem.6f0fcdd7.js\",\"fqZPY\",\"mention.runtime.9c1ade46.js\",\"lookM\",\"user-header-for-space-with-guests-Light.1b10bf7d.svg\",\"2GHvs\",\"user-header-for-space-with-guests-Dark.3d8c1f10.svg\",\"13QWg\",\"in-trial-feature-gates-banner.8806b663.js\",\"9NxYX\",\"no-restriction-illustration-Light.a376c323.svg\",\"lpZU0\",\"no-restriction-illustration-Dark.8da66227.svg\",\"kgrX3\",\"no-restriction-illustration-pencil-Light.bcc52320.svg\",\"bRk6k\",\"no-restriction-illustration-pencil-Dark.5e6368e9.svg\",\"1DRtS\",\"no-restrictions-illustration-external-share-Light.85b8ab71.svg\",\"hhpRR\",\"no-restrictions-illustration-external-share-Dark.dff9aa3b.svg\",\"6qah4\",\"atl.256998e7.js\",\"42PSc\",\"AutomationPremiumTip.a3abb3d2.js\",\"gkmZg\",\"DevToolsDialog.0f875530.js\",\"kjZZD\",\"vendors~editor_icon-object.e97fc136.js\",\"ffEVr\",\"vendors~editor_icon.92bb159e.js\",\"i3TSs\",\"RestrictionsDialog.c04d446a.js\",\"85liN\",\"InspectPermissionsDialog.78171eaf.js\",\"dTsOE\",\"modal.dc2d010b.js\",\"iQ0Jm\",\"UnarchivePagesLoader.00b28304.js\",\"14XOE\",\"InspectPermissionsDialog.27088c8e.js\",\"69XGw\",\"InspectPermissionsEntryPoint.b4a635c5.js\",\"8sFYu\",\"RestrictionsDialog.7c7444f1.js\",\"iO9O1\",\"personal_space.c63f5733.png\",\"7S4dn\",\"FullPageEditorComponent.18c208aa.js\",\"89b92\",\"PublishButtonWithMoreOptions.51f90e8c.js\",\"bunf9\",\"Controller.68369bac.js\",\"c4Kdp\",\"GeneralAccessLevelSelector.d9c22a04.js\",\"kxRVH\",\"AccessRequestsButton.c0152879.js\",\"hvjHg\",\"PublicLinkPermissionsSpotlight.328990b4.svg\",\"hFMOd\",\"PublicLinkButtonSpotlight.9320b1e3.svg\",\"k0hwN\",\"ShareToSlack.6b2c86a2.js\",\"lVO4z\",\"cs.66d17b1d.js\",\"2FVbf\",\"da.45f5bf76.js\",\"ljo6M\",\"de.87ff8d2a.js\",\"9lT7a\",\"en_GB.3f736bc3.js\",\"cNgJs\",\"en.53674b7a.js\",\"aHeMo\",\"en_ZZ.90d281af.js\",\"8d6ia\",\"es.44f7b6ae.js\",\"jh8UJ\",\"fi.bd46bce1.js\",\"bYwCr\",\"fr.854524fc.js\",\"11NiT\",\"hu.21eb6dc5.js\",\"le8VA\",\"it.111da4a0.js\",\"1beJ2\",\"ja.25f13916.js\",\"1tXCh\",\"ko.c7b3c730.js\",\"jzP8g\",\"nb.6ab8a8d0.js\",\"dJY66\",\"nl.b11fd7f9.js\",\"4foYW\",\"pl.200ddf23.js\",\"j0yc3\",\"pt_BR.3fad7d31.js\",\"RfEmw\",\"ru.64b44490.js\",\"5DOlG\",\"sv.812498a9.js\",\"6rD7n\",\"tr.6280d059.js\",\"1e62a\",\"th.646e04f8.js\",\"eLsCU\",\"uk.87a103d8.js\",\"g9qHs\",\"vi.352e605d.js\",\"2ri5s\",\"zh_TW.40e2425f.js\",\"3k60n\",\"zh.af15c051.js\",\"hxIYN\",\"integration-primer.cead19d9.svg\",\"5oKDR\",\"disabled-alert.0ba0a4e5.svg\",\"dIuhJ\",\"link-filled.19c799b9.js\",\"f9XGo\",\"CoreInvites.aa007e38.js\",\"e39BD\",\"SlackTeamsSpotlight.4131c6b4.js\",\"fniFO\",\"Ed.971a9eb8.svg\",\"b5Vj8\",\"Katina.a5091468.svg\",\"aNfB2\",\"Myra.bfce28e5.svg\",\"jpChu\",\"Oliver.efa0d68b.svg\",\"3IQHf\",\"slackSpotlight.c7655f37.svg\",\"35VU5\",\"cs.d801dcbc.js\",\"6W6gh\",\"da.bac7ddcf.js\",\"bfTAm\",\"de.c95398fc.js\",\"fP9up\",\"en_GB.98e5ca88.js\",\"hc0i6\",\"en.8117d663.js\",\"15E48\",\"en_ZZ.00ef7c85.js\",\"jLWG0\",\"es.7e41636e.js\",\"9J49E\",\"fi.89090e5d.js\",\"br9SP\",\"fr.2a048ea9.js\",\"5h4sF\",\"hu.c2dc4635.js\",\"1MV5Z\",\"it.05b27b71.js\",\"iV5Fv\",\"ja.7b259d22.js\",\"7R5mJ\",\"ko.203f86ca.js\",\"5XMUp\",\"nb.e44f5efd.js\",\"jaDFz\",\"nl.405ee529.js\",\"LOg5S\",\"pl.23c5179b.js\",\"lnJdQ\",\"pt_BR.805e95d7.js\",\"hqsLl\",\"ru.c980f637.js\",\"j0btO\",\"sv.9635f53d.js\",\"2YEqr\",\"tr.ddf2ab95.js\",\"7zFV7\",\"th.3ecc11fa.js\",\"fZ22O\",\"uk.04a59e12.js\",\"4tleS\",\"vi.cca22a6d.js\",\"bE6tX\",\"zh_TW.af40ed8f.js\",\"esYD7\",\"zh.8eeac7b4.js\",\"7oczk\",\"cs.f94e9acb.js\",\"e2gl6\",\"da.452fc83f.js\",\"9oo3s\",\"de.e603f414.js\",\"fRPrc\",\"en_GB.113ccfd3.js\",\"dC0KT\",\"en.2f60c19a.js\",\"gbKsh\",\"en_ZZ.71260efd.js\",\"1ZyUV\",\"es.30208975.js\",\"6tijD\",\"et.a748dc81.js\",\"6fkVy\",\"fi.6cd6b4f0.js\",\"5nw5x\",\"fr.183ce9c7.js\",\"jK12s\",\"hu.f759293a.js\",\"6lWvL\",\"is.e7fee0c5.js\",\"kk9To\",\"it.4d1316fd.js\",\"lyt83\",\"ja.8bae3143.js\",\"2uvfp\",\"ko.c72b821f.js\",\"4Wx8B\",\"nb.6f591f7c.js\",\"huTg5\",\"nl.19b2af2c.js\",\"fPfEd\",\"pl.d1f6bfb2.js\",\"fTYhL\",\"pt_BR.dc22514f.js\",\"dVHhf\",\"pt_PT.137566ba.js\",\"2SsCI\",\"ro.a2a72a07.js\",\"kVi5E\",\"ru.20b35c16.js\",\"6HoYh\",\"sk.63554299.js\",\"kOAvl\",\"sv.9189f5e0.js\",\"5ErHy\",\"tr.da3f85c6.js\",\"jJzpI\",\"th.32ffc0a2.js\",\"2PvRH\",\"uk.7f0edb44.js\",\"eUGjU\",\"vi.f2681927.js\",\"drbCf\",\"zh_TW.356972f3.js\",\"5dk6T\",\"zh.063dc4ca.js\",\"7pAFt\",\"WarningIllustration.8adc2aae.js\",\"2CfIU\",\"WarningIllustration.ec26752f.png\",\"g7QTt\",\"CoreInvites.aa4f9f3f.js\",\"i0gb6\",\"CoreInvites.runtime.e67fa744.js\",\"1TOYq\",\"CoreInvites.0dca447d.js\",\"2iqdN\",\"EditorContentStateComponent.b453cc75.js\",\"34k9U\",\"ObjectSidebarControl.cff47818.js\",\"k8hvy\",\"ObjectSidebarControl.runtime.e284ad02.js\",\"fwbht\",\"ShareButton.f93da2c5.js\",\"i0gb6\",\"CoreInvites.runtime.e67fa744.js\",\"k8hvy\",\"ObjectSidebarControl.runtime.e284ad02.js\",\"24IdC\",\"Publish-Modal-Background-Image-Light.4e795a9a.svg\",\"dXonJ\",\"Publish-Modal-Background-Image-Dark.cd843bfb.svg\",\"fJjZJ\",\"PublishPageAsBlogDialog.8de2d772.js\",\"dq8Jz\",\"FullPageEditorComponent.f69899ed.js\",\"i5Fj1\",\"data-classification.b4c9db6d.js\",\"jnk96\",\"DataClassification.96a4949a.js\",\"gEi5K\",\"NotFound.6326a8bd.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"2F69B\",\"vendors~small-pkgs.72a99ece.js\",\"bn8Oy\",\"OverviewNotFound.6fdd31cc.js\",\"4jFyQ\",\"icon-space-overview-empty.106059f9.svg\",\"3b99S\",\"EditorContentClassificationTag.d9726fb7.js\",\"1zPhe\",\"EditorDataClassification.d164af03.js\",\"avzJW\",\"EditorDataClassificationComponent.a0d19f8b.js\",\"4Oj5y\",\"ContentTypeClassification.4e6b4f1b.js\",\"iJsKa\",\"ClassificationReadViewPopup.916ee61f.js\",\"cEDfx\",\"DataClassificationHoverButton.229e6e5c.js\",\"9wTW2\",\"EditorClassificationTagWrapper.f24b8d90.js\",\"5zDuS\",\"NativeCollabComponent.2d426b34.js\",\"5odbj\",\"ClassificationTagButtonError.1b9558b9.js\",\"4Qstt\",\"ClassificationEditModal.928a4a72.js\",\"58UdM\",\"ClassificationEditViewPopup.c3b1a30d.js\",\"gZ0i8\",\"PublishHubDialog.8c895718.js\",\"57vSc\",\"PublishButtonWithMoreOptions.637f20c9.js\",\"anQQJ\",\"PublishModal.fe142cb5.js\",\"36rXN\",\"MovePageDialog.203d95d6.js\",\"ltXeo\",\"PageTree.426ae1e0.js\",\"dviIw\",\"CollapsibleSection.87723006.js\",\"dkv9z\",\"PageTreeAfterIcon.541ae001.js\",\"9F7vX\",\"CreateContentPopover.18986a3b.js\",\"bAbyV\",\"top-nav.5a6babce.js\",\"f1WN5\",\"top-nav.ff89effc.js\",\"7ZpqL\",\"top-nav.4e7cc26e.js\",\"dwffN\",\"GlobalCreateContentPopoverMenu.a78ae85f.js\",\"kiDFE\",\"CreateSpaceMenuItem.ea370925.js\",\"cZgEZ\",\"ContentTreeOnboarding.0a72cc8d.js\",\"6fU2k\",\"drag-handle.629d4432.js\",\"lWi9V\",\"CreateSpaceMenuItemNav3.1b2a8415.js\",\"3tVyh\",\"CreateSpacePlusButton.9425428f.js\",\"dLkMK\",\"FullPageEditorComponent.38305f1c.js\",\"np2ZB\",\"NonMasteredUserModal.9a34fe35.js\",\"j2eUy\",\"nonMasteredUserModalSplashImage.90ba8397.svg\",\"hq1Iv\",\"masteringFlowSplashImage.1f9bd0cc.svg\",\"2a8Ft\",\"is-supported.fbac545d.js\",\"7p6A4\",\"is-supported.becb4292.js\",\"cvmv4\",\"esm.cfbad62d.js\",\"hFfgY\",\"esm.2186c1b5.js\",\"fKpYd\",\"esm.fdbdb29e.js\",\"12s7O\",\"esm.af4ff8f4.js\",\"lFp1i\",\"FullPageEditorComponent.2efc843f.js\",\"daoWf\",\"LoomCrossSellPopupCardImage.6e60c328.png\",\"jBwbI\",\"LoomMigrationModalManager.bdc7286e.js\",\"3jZMP\",\"loomMigrationModalImage.fa8ef03b.svg\",\"1wrZ9\",\"vector.07efb279.svg\",\"014Eq\",\"pageHeaderSpotlightImage.b1e98e59.png\",\"ipnbL\",\"createSpotlightImage.f64dc988.png\",\"2oVPY\",\"ContextualCreateContentPopoverMenu.b789f086.js\",\"hr1db\",\"DatabaseGAOnboarding.fdc4cc79.svg\",\"h4qu8\",\"LiveDocsIntroGif.d2fc0787.gif\",\"j7hKO\",\"LiveDocIntroGADark.45e6357d.svg\",\"7yu5V\",\"LiveDocIntroGALight.8a32f41a.svg\",\"5TJ4V\",\"WhiteboardExperimentSpotlightImage.49c94c1b.svg\",\"iUB8p\",\"WhiteboardsPaywall.cf2c63af.svg\",\"1TlSS\",\"WhiteboardsPaywallDark.0948bce6.svg\",\"e9W8R\",\"ContextualCreateContentPopoverMenu.4e859924.js\",\"aGZFn\",\"modal.5010df70.js\",\"cp1n9\",\"TreeBottomCreateButton.126659d4.js\",\"4Dabn\",\"ContextualCreateContentPopoverMenu.f40912c2.js\",\"5Ixal\",\"CreateFolderPopoverItemSpotlight.0dc0692c.svg\",\"lzaHa\",\"FullPageEditorComponent.5844519e.js\",\"aodrz\",\"FullPageEditorComponent.eedad35f.js\",\"g9CVe\",\"mention.28df720c.js\",\"16ht2\",\"CreateFromTemplate.39750242.js\",\"hvHZS\",\"TemplatePreview.2b6344f0.js\",\"6JdS4\",\"blogPostIcon.e3cb4562.svg\",\"5fnDv\",\"loadingErrorIcon.3c97c605.svg\",\"bupWa\",\"PopupPreview.b63346ae.js\",\"3yGMH\",\"displayErrorIcon.3bd706b2.svg\",\"4NgYy\",\"ContextualCreateContentPopoverMenu.2ada1402.js\",\"clpSH\",\"PageTreeQuickActions.53d44124.js\",\"13PnU\",\"QuickActionsContent.05b00d4a.js\",\"9QyoN\",\"PageQuickActionAutomationMenu.58a3878c.js\",\"05d2I\",\"RendererContentStateWithSpotlight.173338fc.js\",\"9YGIy\",\"DeleteNestedPagesAction.10d2a285.js\",\"iomzR\",\"DeletePageDialog.03d0d714.js\",\"k3BGs\",\"DeleteNestedPagesAction.da65be3a.js\",\"adHzf\",\"DeleteNestedPagesAction.af5a528e.js\",\"72Gwk\",\"nativeEditorComponentsPreloader.52a741af.js\",\"4JUnA\",\"BulkDeletePagesAction.c0f58965.js\",\"5YvMC\",\"BulkChangeOwnerAction.e612d675.js\",\"bXkeF\",\"BulkChangeStatusAction.c76086be.js\",\"leIbB\",\"BulkChangeStatusAction.ec424326.js\",\"1aFR7\",\"NestedChangeOwnerAction.f8ad4630.js\",\"Pp5sV\",\"NestedConvertPageToLiveDocAction.9804acc9.js\",\"lgZ1d\",\"BulkConvertPageToLiveDocAction.14c6b60a.js\",\"p4ay7\",\"CopyPageTreeContainer.1b6761ef.js\",\"2tDVK\",\"UnarchivePagesLoader.5d46e036.js\",\"gLxW3\",\"UnarchivePagesLoader.da52f784.js\",\"bW8TA\",\"CommentEditor.a8a19c97.js\",\"5ko8n\",\"MovePageDialog.9687464c.js\",\"f9QHk\",\"TreeMonitor.3caa2a6d.js\",\"aoUod\",\"MoveBlogModal.d88c6412.js\",\"kRtpG\",\"QuickActionsContent.db7e4d94.js\",\"3D26r\",\"QuickActionsContent.runtime.c5277c5f.js\",\"3D26r\",\"QuickActionsContent.runtime.c5277c5f.js\",\"PNyg1\",\"InlineRename.7ba3b483.js\",\"emopq\",\"MovePageDialog.81048606.js\",\"3L1uC\",\"PageTreeErrorComponent.b558e03e.js\",\"dhqJV\",\"FooterCreateButtons.84da1680.js\",\"67Pvd\",\"ContentTreeOnboarding.c05390e9.js\",\"e19Zv\",\"LiveDocsIconTile.31afeae9.js\",\"d1QkY\",\"TreeBottomCreateButton.b548d881.js\",\"fnoJZ\",\"HomepageIcon.129a4e5b.js\",\"6gau7\",\"DraftLozenge.b210c68f.js\",\"iQam7\",\"page.6c3ca97c.svg\",\"jIvk7\",\"whiteboard.d5787185.svg\",\"cuVen\",\"PublishButtonWithMoreOptions.f7a815a2.js\",\"fCqMy\",\"DiscardModal.4847d4f2.js\",\"a6uKK\",\"CancelSchedulePublishModal.bbc4760e.js\",\"h2HOI\",\"PublishModalMountPoint.de2965cb.js\",\"kXcA7\",\"PublishModalKeyboardShortcuts.926c177f.js\",\"c0RpY\",\"NativeCollabComponent.69e00edb.js\",\"2VACG\",\"RestrictionsUpsellDialog.f08f451c.js\",\"9PeA0\",\"GrantAccessDialog.4907ad9b.js\",\"4mWJk\",\"GrantAccessFlag.26b1807b.js\",\"bfhXH\",\"RestrictionsButton.66af162f.js\",\"lk4cE\",\"RequestAccessPopup.382ca9db.js\"]"));


//# sourceMappingURL=QuickActionsContent.579d88b7.js.map
